export enum Action {
    SAVE = "SAVE",
    FINISH = "FINISH",
    CANCEL= "CANCEL"
}